export default __webpack_public_path__ + "static/media/card_2.a64faea3.svg";